var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between w-100 mt-auto"},[_c('label',{staticClass:"d-flex justify-content-center align-items-center mb-0 text-center font-weight-bold"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }